/**
 * Icon theme — RTL runtime helpers
 * - Patches Flickity options for RTL locales (keeps product media LTR)
 * - Re-patches configs after Shopify section reloads
 */
(function () {
  'use strict';

  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  var MEDIA_LTR_SELECTOR =
    '.product__section-images, .js-product-gallery, .product-gallery, .product-static-gallery, .pswp';

  function isMediaCarousel(elem) {
    if (!elem || !elem.closest) return false;
    return Boolean(elem.closest(MEDIA_LTR_SELECTOR));
  }

  function enhanceOptions(opts, elem) {
    var next = Object.assign({}, opts || {});
    if (isMediaCarousel(elem)) return next;
    // Arabic: content advances RTL; physical arrow sides mirrored in rtl.css
    next.rightToLeft = true;
    if (next.cellAlign === 'left') next.cellAlign = 'right';
    return next;
  }

  function patchDomConfigs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-flickity], [data-flickity-config]').forEach(function (el) {
      if (isMediaCarousel(el)) return;
      ['data-flickity', 'data-flickity-config'].forEach(function (attr) {
        var raw = el.getAttribute(attr);
        if (!raw) return;
        try {
          var opts = JSON.parse(raw);
          if (opts.rightToLeft === true) return;
          el.setAttribute(attr, JSON.stringify(enhanceOptions(opts, el)));
        } catch (e) {
          /* ignore invalid JSON */
        }
      });
    });
  }

  var flickityRef;
  Object.defineProperty(window, 'Flickity', {
    configurable: true,
    enumerable: true,
    get: function () {
      return flickityRef;
    },
    set: function (Orig) {
      // Flickity bootstraps as {} namespace first, then the constructor.
      if (!Orig || typeof Orig !== 'function' || Orig.__baRtlWrapped) {
        flickityRef = Orig;
        return;
      }

      function Wrapped(elem, opts) {
        return new Orig(elem, enhanceOptions(opts, elem));
      }

      Wrapped.prototype = Orig.prototype;
      Object.getOwnPropertyNames(Orig).forEach(function (key) {
        try {
          Wrapped[key] = Orig[key];
        } catch (e) {
          /* read-only static */
        }
      });
      Wrapped.__baRtlWrapped = true;
      flickityRef = Wrapped;
    }
  });

  patchDomConfigs(document);

  document.addEventListener('shopify:section:load', function (event) {
    patchDomConfigs(event.target || document);
  });
})();
